import React from "react";

const ImgFill = ({ className }) => {
  return (
    <svg
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.8127 0.000120016C16.5102 0.000120016 17.0752 0.58376 17.0752 1.30469V12.6954C17.0752 13.4161 16.507 14 15.8127 14L1.2625 13.9999C0.565026 13.9999 0 13.4162 0 12.6953V1.30457C0 0.583933 0.568186 0 1.2625 0L15.8127 0.000120016ZM1.26475 1.62887V9.71322C1.26475 9.89558 1.34105 9.91697 1.43525 9.76521L3.63391 6.22303C4.01107 5.61553 4.58725 5.638 4.92339 6.26893L5.44745 7.25252C5.53083 7.40898 5.67599 7.41674 5.76973 7.26589L7.56577 4.37869C7.9414 3.77504 8.53697 3.78228 8.89387 4.39893L11.7237 9.28887C11.8122 9.44147 11.9578 9.44219 12.048 9.28797L12.4062 8.67452C12.7651 8.06046 13.3882 8.03408 13.7955 8.62L15.6256 11.253C15.7279 11.4005 15.8104 11.372 15.8104 11.1908L15.8105 1.63085C15.8105 1.44686 15.6684 1.30246 15.493 1.30246L1.58211 1.3024C1.40875 1.3024 1.26475 1.44856 1.26475 1.62887Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ImgFill;
